import type { Author } from "@/fixtures/ej-health/fixtures";

/**
 * One row in a listing.
 *
 * Some categories are bylined (醫生專欄, 醫健一分鐘, 醫學通識, 食出健康,
 * 運動懶人包, 健康財富 — every article carries a doctor's avatar and name) and
 * two are video categories (醫生會客室, 動出健康). Rather than a second item
 * type for each, the extra fields are optional here and `ListingPage` picks the
 * renderer: `duration` is what a video card needs, `author` what a bylined card
 * shows.
 */
export type ArticleListItem = {
  title: string;
  excerpt: string;
  time: string;
  img: string;
  category?: string;
  author?: Author;
  duration?: string;
  subscriberOnly?: boolean;
};

export const ARTICLE_LIST: ArticleListItem[] = [
  {
    title: "世界肥胖日｜台灣醫生推「2分鐘行樓梯法」內臟脂肪激減13%",
    excerpt:
      "昨日（3月4日）是世界肥胖日，政府亦藉此呼籲大眾關注體重管理，減低肥胖帶來的健康危機。現代人生活節奏急速，「無時間做運動...",
    time: "15分鐘前",
    img: "/images/ej-health/hero-stairs-method-v2.png",
  },
  {
    title: "【木瓜】一文看清營養價值、好處、卡路里、食譜及食用禁忌",
    excerpt:
      "木瓜（Papaya）是熱帶地區最常見的水果之一，在香港街市和超市全年都能輕鬆買到。木瓜卡路里高唔高？木瓜真的能豐胸嗎？生...",
    time: "30分鐘前",
    img: "/images/ej-health/hero-papaya-v2.png",
  },
  {
    title: "【五指毛桃】一文看清營養價值、好處、禁忌及食譜",
    excerpt:
      "五指毛桃是嶺南地區家喻戶曉的藥食兩用植物，其根部富含多種營養素與活性成分，素有「南芪」之稱。本文將深入解析五指毛桃的營養...",
    time: "1小時前",
    img: "/images/ej-health/article-fivefingerherb.png",
  },
  {
    title: "【大蒜】一文看清營養價值、食用好處、卡路里、食譜及禁忌",
    excerpt:
      "大蒜除了調味還有甚麼功效？大蒜營養價值極高，富含大蒜素，有助殺菌、降血壓及抗氧化。本文詳解大蒜的卡路里與營養成分，剖析生...",
    time: "2小時前",
    img: "/images/ej-health/thumb-garlic.png",
  },
  {
    title: "【西蘭花】一文看清營養價值、好處、卡路里及3款簡易食譜",
    excerpt:
      "西蘭花有甚麼好處？作為公認的超級食物，它富含維他命C及抗氧化物。本文由營養師拆解西蘭花卡路里、6大營養價值、破解「變黃還...",
    time: "3小時前",
    img: "/images/ej-health/thumb-broccoli.png",
  },
  {
    title: "【三文魚】一文看清營養價值、好處、卡路里禁忌及食譜",
    excerpt:
      "三文魚（Salmon）被譽為「水中珍品」，是不少香港人最愛的魚類之一，無論是刺身、香煎還是煙燻都各有風味。想知道三文魚卡...",
    time: "5小時前",
    img: "/images/ej-health/thumb-salmon.png",
  },
  {
    title: "【士多啤梨】一文看清營養價值、卡路里、好處、清洗方法禁忌及食譜",
    excerpt:
      "想知道士多啤梨營養價值有幾高？這種水果不僅低卡路里，更富含維他命C和抗氧化物。本文為你詳細拆解食用士多啤梨的7大好處、清...",
    time: "8小時前",
    img: "/images/ej-health/thumb-strawberry.png",
  },
  {
    title: "【冬瓜】一文看清營養價值、好處、卡路里及3款簡易食譜",
    excerpt:
      "想知道冬瓜營養價值有多高？冬瓜不只低卡去水腫，更能美白養顏。本文由註冊營養師審核，詳列冬瓜卡路里、5大食用好處及禁忌，即...",
    time: "12小時前",
    img: "/images/ej-health/thumb-winter-melon.png",
  },
  {
    title: "【五指毛桃】一文看清營養價值、好處、禁忌及食譜",
    excerpt:
      "五指毛桃是嶺南地區家喻戶曉的藥食兩用植物，其根部富含多種營養素與活性成分，素有「南芪」之稱。本文將深入解析五指毛桃的營養...",
    time: "1小時前",
    img: "/images/ej-health/article-fivefingerherb.png",
  },
  {
    title: "【大蒜】一文看清營養價值、食用好處、卡路里、食譜及禁忌",
    excerpt:
      "大蒜除了調味還有甚麼功效？大蒜營養價值極高，富含大蒜素，有助殺菌、降血壓及抗氧化。本文詳解大蒜的卡路里與營養成分，剖析生...",
    time: "2小時前",
    img: "/images/ej-health/thumb-garlic.png",
  },
  {
    title: "【三文魚】一文看清營養價值、好處、卡路里禁忌及食譜",
    excerpt:
      "三文魚（Salmon）被譽為「水中珍品」，是不少香港人最愛的魚類之一，無論是刺身、香煎還是煙燻都各有風味。想知道三文魚卡...",
    time: "5小時前",
    img: "/images/ej-health/thumb-salmon.png",
  },
  {
    title: "【士多啤梨】一文看清營養價值、卡路里、好處、清洗方法禁忌及食譜",
    excerpt:
      "想知道士多啤梨營養價值有幾高？這種水果不僅低卡路里，更富含維他命C和抗氧化物。本文為你詳細拆解食用士多啤梨的7大好處、清...",
    time: "8小時前",
    img: "/images/ej-health/thumb-strawberry.png",
  },
  {
    title: "衞生防護中心籲市民盡早接種流感疫苗　本周流感活躍度持續上升",
    excerpt:
      "衞生防護中心今日公布最新監測數據，季節性流感活躍程度連續第三周上升，學校及院舍爆發個案明顯增加。中心提醒高風險人士應盡早...",
    time: "20分鐘前",
    img: "/images/ej-health/hero-stairs-method-v2.png",
  },
  {
    title: "【藍莓】護眼抗氧化之王　營養師拆解每日建議食用分量",
    excerpt:
      "藍莓被譽為「超級食物」，富含花青素與維他命C，有助護眼、抗氧化及延緩衰老。但藍莓糖分如何？每日食多少才適合？本文由註冊營...",
    time: "45分鐘前",
    img: "/images/ej-health/thumb-broccoli.png",
  },
  {
    title: "研究：每日步行8000步　全因死亡風險可降低逾五成",
    excerpt:
      "一項橫跨十年的大型追蹤研究發現，與每日步行少於4000步的人相比，達到8000步者的全因死亡風險顯著下降，心血管疾病風險亦...",
    time: "1小時前",
    img: "/images/ej-health/hero-stairs-method-v2.png",
  },
  {
    title: "【蕃茄】茄紅素護心防癌　生食熟食吸收大不同",
    excerpt:
      "蕃茄含有豐富茄紅素，是強效抗氧化物，有助護心及降低部分癌症風險。不過茄紅素在加熱後更易吸收，生食與熟食該如何選擇？本文一...",
    time: "2小時前",
    img: "/images/ej-health/thumb-broccoli.png",
  },
  {
    title: "消委會檢測30款食油　兩款樣本塑化劑含量超出參考上限",
    excerpt:
      "消費者委員會測試市面30款常見食油，發現大部分樣本品質理想，惟兩款檢出塑化劑含量超出歐盟參考上限。消委會建議市民選購時留...",
    time: "3小時前",
    img: "/images/ej-health/thumb-garlic.png",
  },
  {
    title: "【牛油果】優質好脂肪助降膽固醇　高熱量減肥要適量",
    excerpt:
      "牛油果含豐富單元不飽和脂肪及膳食纖維，有助降低壞膽固醇、穩定血糖。但牛油果卡路里偏高，減肥人士應如何控制分量？本文詳細拆...",
    time: "4小時前",
    img: "/images/ej-health/thumb-broccoli.png",
  },
  {
    title: "港大研發新血液測試　有望提升早期大腸癌診斷準確度",
    excerpt:
      "香港大學醫學院研究團隊公布一項嶄新血液測試技術，透過分析特定基因標記，有望以非入侵方式協助早期偵測大腸癌，提升篩查效率與...",
    time: "6小時前",
    img: "/images/ej-health/article-fivefingerherb.png",
  },
  {
    title: "【杏仁】堅果之王護心又控糖　每日一手分量最適宜",
    excerpt:
      "杏仁富含維他命E、膳食纖維及不飽和脂肪，有助護心、穩定血糖及增加飽足感。不過堅果熱量不低，每日應食用多少？本文由營養師逐...",
    time: "7小時前",
    img: "/images/ej-health/thumb-garlic.png",
  },
  {
    title: "中大研究：長期維持地中海飲食　有效延緩認知功能退化",
    excerpt:
      "香港中文大學一項長者追蹤研究發現，恆常採用以蔬果、全穀、橄欖油及魚類為主的地中海飲食模式，與較慢的認知退化速度相關，對預...",
    time: "9小時前",
    img: "/images/ej-health/hero-papaya-v2.png",
  },
  {
    title: "【菠菜】鐵質葉酸豐富改善貧血　孕婦及素食者恩物",
    excerpt:
      "菠菜含豐富鐵質、葉酸及維他命K，有助改善貧血及支援胎兒發育，是孕婦與素食者的優質之選。不過菠菜草酸較高，怎樣食用更健康？...",
    time: "10小時前",
    img: "/images/ej-health/thumb-broccoli.png",
  },
  {
    title: "流感高峰期殺到　兒科醫生教家長辨別徵狀及照顧貼士",
    excerpt:
      "踏入流感高峰期，兒童感染個案上升。兒科專科醫生提醒家長留意持續高燒、精神不振等警號，並分享退燒、補水及何時求診的實用照顧...",
    time: "11小時前",
    img: "/images/ej-health/thumb-salmon.png",
  },
  {
    title: "【奇異果】維他命C爆錶　助消化、提升免疫力一文看清",
    excerpt:
      "奇異果維他命C含量極高，並含豐富膳食纖維及奇異果酵素，有助促進消化、增強免疫力。金奇異果與綠奇異果有何分別？本文為你逐一...",
    time: "13小時前",
    img: "/images/ej-health/thumb-strawberry.png",
  },
];

export const RELATED_TAGS_MEDICAL = [
  "營養學",
  "木瓜",
  "五指毛桃",
  "三高",
  "慢性疾病共同治理先導計劃",
  "慢病共治計劃",
  "食物安全",
  "尼帕病毒",
  "傳染病",
  "食物金字塔",
  "飲食金字塔",
];
